import { Dispatch, useEffect, useState } from 'react';
import {
  getDictionaryHistory,
  getDownLoadItems,
  getAdminAllStudio,
  getDownLoadVersionItems,
  getDownLoadRecord,
} from '../../../api';
import { getLocalTime, strToJson } from '../../../lib';
import {
  UniqueKey,
  IHistoryValue,
  CommonStatusStep,
  IDownLoadMenu,
  IStudioInfo,
  IDownLoadVersionMenu,
  DownloadPlatformType,
  IEngineItem,
} from '../../../model/api-modules';
import moment from 'moment';
import { AutoAntTable } from '../../../components/auto-ant-table';

import { wrapRequestArea } from '../../../lib/http/lib';
import { CustomPopover } from '../../../components/custom-popover';
import { useSelector, useDispatch } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { SystemMenuId } from '../../../model/system/menu';
import { ColumnType } from 'antd/lib/table';
import { CommonButton } from '../../../components/button/main';
import { exportDownloadRecordXlsx } from './export';
import downloadBalanceIcon from '../../../assets/svg/download-balance.svg';
import { ICommonSupportPageProps } from '../../../model';
import { EngineVersionSelect } from './engine-version';

interface IEngineVersion {
  sdkName: string;
  sdkVersionList: string[];
}

export const AdminDownLoadRecord = (props: ICommonSupportPageProps) => {
  const { site } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<IHistoryValue[]>([]);
  const [downLoadList, setDownLoadList] = useState<IDownLoadMenu[]>([]);
  const [studioList, setStudioList] = useState<IStudioInfo[]>([]);
  const [downLoadVersionList, setDownLoadVersionList] = useState<
    IDownLoadVersionMenu[]
  >([]);
  const [exportList, setExportList] = useState<IHistoryValue[]>([]);
  const [engineVersionData, setEngineVersionData] = useState<any[]>([]);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.DownLoadRecord,
  });

  const platformsList = [
    {
      label: 'Android',
      value: DownloadPlatformType.Android,
    },
    {
      label: 'iOS',
      value: DownloadPlatformType.IOS,
    },
    {
      label: 'Mac',
      value: DownloadPlatformType.Mac,
    },
    {
      label: 'PS4',
      value: DownloadPlatformType.PS4,
    },
    {
      label: 'PS5',
      value: DownloadPlatformType.PS5,
    },
    {
      label: 'Switch',
      value: DownloadPlatformType.Switch,
    },
    {
      label: 'Windows',
      value: DownloadPlatformType.Windows,
    },
    {
      label: 'XSX',
      value: DownloadPlatformType.XSX,
    },
  ];

  const isJSON = (value: any) => {
    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  const getJsonToParse = (value: any) => {
    if (isJSON(value)) {
      return JSON.parse(value);
    }
    return value;
  };

  // 获取历史记录列表
  const getHistoryList = async (key: UniqueKey) => {
    setLoading(true);
    const res = await wrapRequestArea(() => getDictionaryHistory(key), site);
    const result: any = await wrapRequestArea(() => getDownLoadRecord(), site);
    if (res && result) {
      const data: IHistoryValue[] =
        getJsonToParse(res[key]?.HistoryValue) || [];
      const resultData = result?.list?.map((item: any) => {
        return {
          ...item,
          Value: JSON.stringify(item.Value),
        };
      });
      const newData = data.concat(resultData || []);

      setTableData(
        newData
          .sort((a: any, b: any) => {
            const dateA = moment(a.ModifyTime || a.CreateTime);
            const dateB = moment(b.ModifyTime || b.CreateTime);
            return dateB.diff(dateA);
          })
          .map((item) => {
            return { ...item, ...strToJson(item.Value || '{}') };
          }) || []
      );
      setExportList(
        newData
          .sort((a: any, b: any) => {
            const dateA = moment(a.ModifyTime || a.CreateTime);
            const dateB = moment(b.ModifyTime || b.CreateTime);
            return dateB.diff(dateA);
          })
          .map((item) => {
            return { ...item, ...strToJson(item.Value || '{}') };
          }) || []
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    getDownLoadObjectList();
    getDownLoadVersionList();
    getStudioList();
    getHistoryList(UniqueKey.DownloadCenter);
  }, [site]);

  const getStudioList = async () => {
    const res = await wrapRequestArea(getAdminAllStudio, site);
    if (res) {
      setStudioList(res);
    }
  };
  const getDownLoadObjectList = async () => {
    const res = await wrapRequestArea(getDownLoadItems, site);
    if (res) {
      setDownLoadList(res);
    }
  };
  const getDownLoadVersionList = async () => {
    const res = await wrapRequestArea(getDownLoadVersionItems, site);
    if (res) {
      setDownLoadVersionList(res);
      //   const newEngineJson: IEngineItem[] = [];
      //   if (item?.EngineJson?.length !== 0) {
      //     item.EngineJson?.forEach(it => {
      //       newEngineJson.push(it);
      //     });
      //   } else if (item?.SubVersions?.length !== 0) {
      //     item.SubVersions?.forEach(it => {
      //       it.EngineJson?.length !== 0 && it.EngineJson.forEach(i => {
      //         newEngineJson.push(i);
      //       });
      //     });
      //   }

      //   // 遍历 EngineJson 数组
      //   newEngineJson.length !== 0 && newEngineJson.forEach((engineItem) => {
      //     const { type, version } = engineItem;

      //     // 如果该 type 不存在，初始化为空数组
      //     if (!acc[type]) {
      //       acc[type] = [];
      //     }

      //     // 合并并去重
      //     acc[type] = Array.from(new Set([...acc[type], ...version]));
      //   });

      //   return acc;
      // }, {} as Record<number, string[]>);
      const result = res.reduce<Record<number, string[]>>((acc, item) => {
        const newEngineJson: IEngineItem[] = [
          ...(item?.EngineJson || []),
          ...(item?.SubVersions?.flatMap((sub) => sub.EngineJson || []) || []),
        ].filter(Boolean);

        // 遍历 EngineJson 数组
        newEngineJson.forEach((engineItem) => {
          const { type, version } = engineItem;

          if (type > 3) return;

          if (!acc[type]) {
            acc[type] = [];
          }

          acc[type] = Array.from(new Set([...acc[type], ...version]));
        });

        return acc;
      }, {});
      const engineVersionData = Object.entries(result).map(
        ([sdkName, sdkVersionList]) => ({
          sdkName: getEngineName(parseInt(sdkName)),
          sdkVersionList,
        })
      );
      setEngineVersionData(engineVersionData);
    }
  };

  const getEngineName = (value: number) => {
    if (value === 1) {
      return 'UE Plugin';
    }
    if (value === 2) {
      return 'C++';
    }
    if (value === 3) {
      return 'Unity Plugin';
    }
    return '';
  };

  const contactColumns: ColumnType<IHistoryValue>[] = [
    {
      title: '下载人',
      dataIndex: 'Value',
      key: 'Name',
      width: '130px',
      fixed: 'left',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const emailArr = value.uid?.split('@') || [''];
        return <span>{emailArr?.[0]}</span>;
      },
    },
    {
      title: '下载人邮箱',
      dataIndex: 'Value',
      key: 'Uid',
      fixed: 'left',
      render: (record: string) => {
        const value = getJsonToParse(record);
        return <span>{value.uid}</span>;
      },
    },
    {
      title: '下载物名称',
      dataIndex: 'Value',
      key: 'ObjectName',
      width: 200,
      fixed: 'left',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const { versionIds, recordBody, versionID } = value;
        let objectName = '';
        if (versionIds) {
          const versionItems: IDownLoadVersionMenu[] = [];
          downLoadVersionList.forEach((item) => {
            if (versionIds && versionIds.indexOf(item.id) !== -1) {
              versionItems.push(item);
            }
          });
          versionItems.forEach((item) => {
            const itemName =
              downLoadList.find((it) => it.id === item.ObjectID)?.Name || '';
            objectName += `${itemName},`;
          });
        } else if (recordBody) {
          recordBody.SdkInfo?.length !== 0 &&
            recordBody.SdkInfo.forEach((item: any) => {
              const versionItem = downLoadVersionList.find(
                (it) => it.id === item.versionID
              );
              const objItem = downLoadList.find((it) => {
                if (versionItem?.ObjectID) {
                  return it.id === versionItem?.ObjectID;
                }
                return null;
              });
              objectName += `${objItem?.Name || ''},`;
            });
        } else if (versionID) {
          const versionItem = downLoadVersionList.find(
            (it) => it.id === value.versionID
          );
          const objItem = downLoadList.find((it) => {
            if (versionItem?.ObjectID) {
              return it.id === versionItem?.ObjectID;
            }
            return null;
          });
          objectName = objItem?.Name || '';
        }
        if (objectName.endsWith(',')) {
          objectName = objectName.slice(0, -1);
        }
        return <CustomPopover content={objectName}>{objectName}</CustomPopover>;
      },
    },
    {
      title: '二级下载物',
      dataIndex: 'Value',
      key: 'SecondDownload',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const { recordBody, subVersionTags } = value;
        let title = '';
        if (recordBody) {
          recordBody?.SdkInfo?.length !== 0 &&
            recordBody?.SdkInfo?.forEach((item: any) => {
              if (item?.subVersionTags?.length !== 0) {
                const subVersion = item?.subVersionTags?.join('、');
                if (subVersion) {
                  title += title ? `,${subVersion}` : subVersion;
                }
              }
            });
        } else if (subVersionTags && subVersionTags.length !== 0) {
          title = subVersionTags.join(',');
        }
        return (
          <CustomPopover content={title || '/'}>{title || '/'}</CustomPopover>
        );
      },
    },
    {
      title: '下载物版本',
      dataIndex: 'Value',
      key: 'SecondDownload',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const { versionIds, recordBody, versionID } = value;
        let version = '';
        if (versionIds) {
          const versionItems: IDownLoadVersionMenu[] = [];
          downLoadVersionList.forEach((item) => {
            if (versionIds && versionIds.indexOf(item.id) !== -1) {
              versionItems.push(item);
            }
          });
          versionItems.forEach((item) => {
            version += `${item.Version || ''},`;
            if (version.endsWith(',')) {
              version = version.slice(0, -1);
            }
          });
        } else if (recordBody) {
          recordBody?.SdkInfo?.length !== 0 &&
            recordBody?.SdkInfo?.forEach((item: any) => {
              const versionItem = downLoadVersionList.find(
                (it) => it.id === item.versionID
              );
              version += version
                ? `,${versionItem?.Version}`
                : versionItem?.Version;
            });
        } else if (versionID) {
          const versionItem = downLoadVersionList.find(
            (it) => it.id === versionID
          );
          if (versionItem) {
            version = versionItem.Version;
          }
        }
        return (
          <CustomPopover content={version || '/'}>
            {version || '/'}
          </CustomPopover>
        );
      },
    },
    {
      title: '平台',
      dataIndex: 'Value',
      key: 'Platforms',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const { platforms, engine } = value;
        let platform = '';
        if (platforms && platforms.length !== 0 && engine) {
          // 只有客户端sdk显示平台
          if (engine?.type === 1 || engine?.type === 2 || engine?.type === 3) {
            platforms.forEach((item: DownloadPlatformType) => {
              if (item === DownloadPlatformType.Android) platform += 'Android,';
              if (item === DownloadPlatformType.IOS) platform += 'iOS,';
              if (item === DownloadPlatformType.Mac) platform += 'Mac,';
              if (item === DownloadPlatformType.PS4) platform += 'PS4,';
              if (item === DownloadPlatformType.PS5) platform += 'PS5,';
              if (item === DownloadPlatformType.Switch) platform += 'Switch,';
              if (item === DownloadPlatformType.Windows) platform += 'Windows,';
              if (item === DownloadPlatformType.XSX) platform += 'XSX,';
            });
          }
        }
        if (platform.endsWith(',')) {
          platform = platform.slice(0, -1);
        }
        return (
          <CustomPopover content={platform || '/'}>
            {platform || '/'}
          </CustomPopover>
        );
      },
    },
    {
      title: '引擎',
      dataIndex: 'Value',
      key: 'SecondDownload',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const { versionIds, recordBody, engine } = value;
        let versionName = '';
        if (versionIds) {
          const versionItems: IDownLoadVersionMenu[] = [];
          downLoadVersionList.forEach((item) => {
            if (versionIds && versionIds.indexOf(item.id) !== -1) {
              versionItems.push(item);
            }
          });
          versionItems.forEach((item) => {
            const engineJson = item.EngineJson[0] || [];
            if (engineJson.type === 1) {
              if (engineJson.version?.length !== 0) {
                versionName += `UE Plugin${engineJson.version},`;
              }
              // if (engineJson.pssdkVersion?.length !== 0) {
              //   versionName += `PS SDK${engineJson.pssdkVersion},`;
              // }
              // if (engineJson.gdkVersion?.length !== 0) {
              //   versionName += `GDK${engineJson.gdkVersion},`;
              // }
            } else if (engineJson?.type === 2) {
              versionName += `C++${engineJson.version},`;
            } else if (engineJson?.type === 3) {
              versionName += `Unity Plugin${engineJson.version},`;
            }
          });
        } else if (recordBody) {
          recordBody.SdkInfo?.length !== 0 &&
            recordBody.SdkInfo.forEach((item: any) => {
              if (item.engine?.type === 1) {
                // UEPlugin = 1,
                // CPP = 2,
                // UnityPlugin = 3,
                // Windows = 4,
                // WinMsvC = 5,
                // Zip = 6,
                if (item.engine?.version) {
                  versionName += `UE Plugin${item.engine?.version},`;
                }
                // if (item.engine?.pssdkVersion) {
                //   versionName += `PS SDK${item.engine?.pssdkVersion},`;
                // }
                // if (item.engine?.gdkVersion) {
                //   versionName += `GDK${item.engine?.pssdkVersion},`;
                // }
              } else if (item.engine?.type === 2) {
                versionName += `C++${item.engine?.version},`;
              } else if (item.engine?.type === 3) {
                versionName += `Unity Plugin${item.engine?.version},`;
              }
            });
        } else if (engine) {
          // UEPlugin = 1,
          // CPP = 2,
          // UnityPlugin = 3,
          // Windows = 4,
          // WinMsvC = 5,
          // Zip = 6,
          if (engine?.type === 1) {
            if (engine?.version) {
              versionName += `UE Plugin${engine?.version},`;
            }
            // if (engine?.pssdkVersion) {
            //   versionName += `PS SDK${engine?.pssdkVersion},`;
            // }
            // if (engine?.gdkVersion) {
            //   versionName += `GDK${engine?.pssdkVersion},`;
            // }
          } else if (engine?.type === 2) {
            versionName += `C++${engine?.version},`;
          } else if (engine?.type === 3) {
            versionName += `Unity Plugin${engine?.version},`;
          }
        }
        if (versionName.endsWith(',')) {
          versionName = versionName.slice(0, -1);
        }
        return (
          <CustomPopover content={versionName || '/'}>
            {versionName || '/'}
          </CustomPopover>
        );
      },
    },
    {
      title: '工作室信息',
      dataIndex: 'Value',
      key: 'LinkInfo',
      width: '250px',
      render: (record: string) => {
        const value = getJsonToParse(record);
        const { studioId, gameName, envName } = value;
        const studioItem = studioList.find(
          (item) => item.StudioID === studioId
        );
        let linkInfo = '';
        if (studioItem?.Name) {
          linkInfo += studioItem.Name;
        }
        if (gameName) {
          linkInfo += `/${gameName}`;
        }
        if (envName) {
          linkInfo += `/${envName}`;
        }
        return <CustomPopover content={linkInfo}> {linkInfo} </CustomPopover>;
      },
    },
    {
      title: '下载状态',
      dataIndex: 'Status',
      key: 'Status',
      width: '120px',
      render: (text: number) => {
        return (
          <span>
            <span
              style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                background:
                  text === CommonStatusStep.Reject ? 'red' : '#00ff7f',
                borderRadius: '5px',
                marginRight: '4px',
              }}
            ></span>
            {text === CommonStatusStep.Reject ? '失败' : '成功'}
          </span>
        );
      },
    },
    {
      title: '下载时间',
      dataIndex: 'Value',
      key: 'DownloadTime',
      width: '180px',
      render: (text: string, record: any) => {
        const time = getLocalTime(
          record.ModifyTime || record.CreateTime,
          userInfo?.UserSettings?.Timezone
        );
        return time;
      },
      // sorter: (a: any, b: any) => {
      //     const dateA = moment(a.ModifyTime);
      //     const dateB = moment(b.ModifyTime);
      //     return dateB.diff(dateA);
      // },
    },
  ];

  const sortDownLoadList = [...downLoadList]
    .filter((item) => !item.ParentTag)
    .sort((a, b) => {
      const strA = a.Name;
      const strB = b.Name;
      return strA.localeCompare(strB);
    });

  return (
    <div>
      <AutoAntTable
        loading={loading}
        dataSource={tableData || []}
        columns={contactColumns}
        configFilter={{
          filters: [
            {
              label: '下载物',
              name: 'downloadItem',
              type: 'multi-select',
              options: sortDownLoadList.map((item) => {
                return { label: item.Name, value: item.Name };
              }),
              filter: (val, record) => {
                const value = getJsonToParse(record.Value);
                const { versionIds, recordBody, versionID } = value;
                let objectName = '';
                if (versionIds) {
                  const versionItems: IDownLoadVersionMenu[] = [];
                  downLoadVersionList.forEach((item) => {
                    if (versionIds && versionIds.indexOf(item.id) !== -1) {
                      versionItems.push(item);
                    }
                  });
                  versionItems.forEach((item) => {
                    const itemName =
                      downLoadList.find((it) => it.id === item.ObjectID)
                        ?.Name || '';
                    objectName += `${itemName},`;
                  });
                } else if (recordBody) {
                  recordBody.SdkInfo?.length !== 0 &&
                    recordBody.SdkInfo.forEach((item: any) => {
                      const versionItem = downLoadVersionList.find(
                        (it) => it.id === item.versionID
                      );
                      const objItem = downLoadList.find((it) => {
                        if (versionItem?.ObjectID) {
                          return it.id === versionItem?.ObjectID;
                        }
                        return null;
                      });
                      objectName += `${objItem?.Name || ''},`;
                    });
                } else if (versionID) {
                  const versionItem = downLoadVersionList.find(
                    (it) => it.id === value.versionID
                  );
                  const objItem = downLoadList.find((it) => {
                    if (versionItem?.ObjectID) {
                      return it.id === versionItem?.ObjectID;
                    }
                    return null;
                  });
                  objectName = objItem?.Name || '';
                }
                if (objectName.endsWith(',')) {
                  objectName = objectName.slice(0, -1);
                }
                const objectArr = objectName.split(',');
                return val.some((item: string) => objectArr.includes(item));
              },
            },
            {
              label: '版本',
              name: 'downloadVersion',
              type: 'multi-select',
              options: downLoadVersionList
                .reduce((acc: any, item) => {
                  // 检查当前 Version 是否已经在累加器中
                  const exists = acc.some(
                    (option: any) => option.label === item.Version
                  );

                  // 如果不存在，才添加到结果中
                  if (!exists) {
                    acc.push({ label: item.Version, value: item.Version });
                  }

                  return acc;
                }, [])
                .sort((a: any, b: any) => {
                  // 将版本号字符串转换为数字数组进行比较
                  const versionA = a.value.split('.').map(Number);
                  const versionB = b.value.split('.').map(Number);

                  // 逐位比较版本号
                  const maxLength = Math.max(versionA.length, versionB.length);

                  for (let i = 0; i < maxLength; i++) {
                    const numA = versionA[i] || 0; // 如果某位不存在，视为 0
                    const numB = versionB[i] || 0;

                    if (numA > numB) return -1; // 大的在前（降序）
                    if (numA < numB) return 1; // 小的在后
                  }

                  return 0; // 相等
                }),
              filter: (val, record) => {
                const value = getJsonToParse(record.Value);
                const { versionIds, recordBody, versionID } = value;
                let version = '';
                if (versionIds) {
                  const versionItems: IDownLoadVersionMenu[] = [];
                  downLoadVersionList.forEach((item) => {
                    if (versionIds && versionIds.indexOf(item.id) !== -1) {
                      versionItems.push(item);
                    }
                  });
                  versionItems.forEach((item) => {
                    version += `${item.Version || ''},`;
                    if (version.endsWith(',')) {
                      version = version.slice(0, -1);
                    }
                  });
                } else if (recordBody) {
                  recordBody?.SdkInfo?.length !== 0 &&
                    recordBody?.SdkInfo?.forEach((item: any) => {
                      const versionItem = downLoadVersionList.find(
                        (it) => it.id === item.versionID
                      );
                      version += version
                        ? `,${versionItem?.Version}`
                        : versionItem?.Version;
                    });
                } else if (versionID) {
                  const versionItem = downLoadVersionList.find(
                    (it) => it.id === versionID
                  );
                  if (versionItem) {
                    version = versionItem.Version;
                  }
                }
                const versionArr = version.split(',');
                return val.some((item: string) => versionArr.includes(item));
              },
            },
            {
              label: '平台',
              name: 'downloadPlatforms',
              type: 'multi-select',
              options: platformsList,
              filter: (val, record) => {
                const value = getJsonToParse(record.Value);
                const { platforms, engine } = value;
                if (platforms && platforms.length !== 0 && engine) {
                  if (
                    engine?.type === 1 ||
                    engine?.type === 2 ||
                    engine?.type === 3
                  ) {
                    return val.some((item: string) => platforms.includes(item));
                  }
                }
                return false;
              },
            },
            {
              name: 'engine',
              render: (commonProps: any) => {
                return (
                  <EngineVersionSelect
                    sdkInfo={engineVersionData}
                    onVersionChange={(values: IEngineVersion[]) => {
                      commonProps.onChange(values);
                    }}
                  />
                );
              },
              filter: (val: IEngineVersion[], record) => {
                const value = getJsonToParse(record.Value);
                const { versionIds, recordBody, engine } = value;
                let versionName = '';
                if (versionIds) {
                  const versionItems: IDownLoadVersionMenu[] = [];
                  downLoadVersionList.forEach((item) => {
                    if (versionIds && versionIds.indexOf(item.id) !== -1) {
                      versionItems.push(item);
                    }
                  });
                  versionItems.forEach((item) => {
                    const engineJson = item.EngineJson[0] || [];
                    if (engineJson.type === 1) {
                      if (engineJson.version?.length !== 0) {
                        versionName += `UE Plugin${engineJson.version},`;
                      }
                      if (engineJson.pssdkVersion?.length !== 0) {
                        versionName += `PS SDK${engineJson.pssdkVersion},`;
                      }
                      if (engineJson.gdkVersion?.length !== 0) {
                        versionName += `GDK${engineJson.gdkVersion},`;
                      }
                    } else if (engineJson?.type === 2) {
                      versionName += `C++${engineJson.version},`;
                    } else if (engineJson?.type === 3) {
                      versionName += `Unity Plugin${engineJson.version},`;
                    }
                  });
                } else if (recordBody) {
                  recordBody.SdkInfo?.length !== 0 &&
                    recordBody.SdkInfo.forEach((item: any) => {
                      if (item.engine?.type === 1) {
                        // UEPlugin = 1,
                        // CPP = 2,
                        // UnityPlugin = 3,
                        // Windows = 4,
                        // WinMsvC = 5,
                        // Zip = 6,
                        if (item.engine?.version) {
                          versionName += `UE Plugin${item.engine?.version},`;
                        }
                        if (item.engine?.pssdkVersion) {
                          versionName += `PS SDK${item.engine?.pssdkVersion},`;
                        }
                        if (item.engine?.gdkVersion) {
                          versionName += `GDK${item.engine?.pssdkVersion},`;
                        }
                      } else if (item.engine?.type === 2) {
                        versionName += `C++${item.engine?.version},`;
                      } else if (item.engine?.type === 3) {
                        versionName += `Unity Plugin${item.engine?.version},`;
                      }
                    });
                } else if (engine) {
                  // UEPlugin = 1,
                  // CPP = 2,
                  // UnityPlugin = 3,
                  // Windows = 4,
                  // WinMsvC = 5,
                  // Zip = 6,
                  if (engine?.type === 1) {
                    if (engine?.version) {
                      versionName += `UE Plugin${engine?.version},`;
                    }
                    if (engine?.pssdkVersion) {
                      versionName += `PS SDK${engine?.pssdkVersion},`;
                    }
                    if (engine?.gdkVersion) {
                      versionName += `GDK${engine?.pssdkVersion},`;
                    }
                  } else if (engine?.type === 2) {
                    versionName += `C++${engine?.version},`;
                  } else if (engine?.type === 3) {
                    versionName += `Unity Plugin${engine?.version},`;
                  }
                }
                if (versionName.endsWith(',')) {
                  versionName = versionName.slice(0, -1);
                }
                const values = val.flatMap((item) => {
                  if (item.sdkVersionList?.length > 0) {
                    return item.sdkVersionList.map(
                      (version) => `${item.sdkName}${version}`
                    );
                  }
                  return [];
                });
                let isFilter = false;
                const filterItem = val.find(
                  (it) => it.sdkVersionList.length !== 0
                );
                if (filterItem) isFilter = true;
                if (!isFilter) {
                  return true;
                }
                return values.some((item: string) =>
                  versionName.includes(item)
                );
              },
            },
            {
              label: '工作室',
              name: 'studio',
              type: 'multi-select',
              options: studioList.map((item) => {
                return {
                  label: `${item.Name} (${item.StudioID})`,
                  value: item.StudioID,
                };
              }),
              filter: (val, record) => {
                return val.some((item: string) => record.studioId === item);
              },
            },
            {
              label: '下载状态',
              name: 'status',
              type: 'select',
              options: ['成功', '失败'].map((item) => {
                return {
                  label: (
                    <span>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '10px',
                          height: '10px',
                          background: item === '失败' ? 'red' : '#00ff7f',
                          borderRadius: '5px',
                          marginRight: '4px',
                        }}
                      ></span>
                      {item}
                    </span>
                  ),
                  value:
                    item === '失败'
                      ? CommonStatusStep.Reject
                      : CommonStatusStep.Resolve,
                };
              }),
              filter: (val, record) => {
                return record.Status === val;
              },
            },
            {
              name: 'ModifyTime',
              type: 'date-range',
              filter: (val, record) => {
                const itemTime = record.ModifyTime || record.CreateTime;
                return (
                  moment(itemTime).isSameOrBefore(val[1]) &&
                  moment(itemTime).isSameOrAfter(val[0])
                );
              },
            },
            {
              name: 'clear',
              type: 'clear-btn',
            },
            {
              name: 'export',
              render() {
                return (
                  <CommonButton
                    iconButton
                    onClick={() => {
                      exportDownloadRecordXlsx(
                        exportList,
                        downLoadList,
                        downLoadVersionList,
                        studioList,
                        userInfo
                      );
                    }}
                    disabled={exportList.length === 0}
                  >
                    <img src={downloadBalanceIcon} width={16} height={16} />
                  </CommonButton>
                );
              },
            },
            {
              name: 'uid',
              type: 'search',
              placeholder: '下载人/邮箱',
              place: 'right',
            },
          ],
          onChange: (
            value: any,
            changeFiled: string,
            filterList: IHistoryValue[]
          ) => {
            setExportList(filterList);
          },
        }}
      />
    </div>
  );
};
